import React from 'react';
import { Wrapper, TextContainer } from 'app/components/transferModule/content/transfer/commonStyles';
import FuPaSkeleton from 'app/styles/skeleton/FuPaSkeleton';
export default function TransferComponentSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: "div",
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TransferComponentSkeleton",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(FuPaSkeleton, {
    variant: "circular",
    width: 56,
    height: 56,
    animation: animation,
    "data-sentry-element": "FuPaSkeleton",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(TextContainer, {
    "data-sentry-element": "TextContainer",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(FuPaSkeleton, {
    variant: "text",
    width: 120,
    height: 14,
    animation: animation,
    "data-sentry-element": "FuPaSkeleton",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(FuPaSkeleton, {
    variant: "text",
    width: 200,
    height: 12,
    animation: animation,
    "data-sentry-element": "FuPaSkeleton",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(FuPaSkeleton, {
    variant: "text",
    width: 60,
    height: 12,
    animation: animation,
    "data-sentry-element": "FuPaSkeleton",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(FuPaSkeleton, {
    variant: "circular",
    width: 24,
    height: 24,
    animation: animation,
    "data-sentry-element": "FuPaSkeleton",
    "data-sentry-source-file": "TransferComponentSkeleton.tsx"
  }));
}